import { Text } from '@vkontakte/vkui';
import React, { type FC, memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { BaseConfirmDialog } from 'reactApp/components/BaseConfirmDialog/BaseConfirmDialog';
import { EButtonType } from 'reactApp/components/BaseConfirmDialog/BaseConformationDialog.types';
import { VK_UI_DARK_THEME } from 'reactApp/constants';
import { resetImageGeneration } from 'reactApp/modules/aiPhotoGeneration/aiPhotoGeneration.actions';
import { sendXray } from 'reactApp/utils/ga';

import styles from './AiGenerationResetModal.css';

export interface DuplicatesRemoveAllModalProps {
    onClose?(): void;
}

export const AiGenerationResetModal: FC<DuplicatesRemoveAllModalProps> = memo(function AiGenerationResetModal(props) {
    const { onClose } = props;

    const dispatch = useDispatch();

    const renderHeader = useCallback(() => <h3 className={styles.title}>Сгенерировать новое изображение?</h3>, []);

    const renderContent = useCallback(
        () => <Text className={styles.description}>Готовое изображение удалится&nbsp;&mdash; восстановить его&nbsp;не&nbsp;получится</Text>,
        []
    );

    const handleClose = useCallback(() => {
        onClose?.();
    }, [onClose]);

    const handleClick = useCallback(() => {
        sendXray(['ai-gen', 'reset', 'click']);
        dispatch(resetImageGeneration());
        handleClose();
    }, [handleClose, dispatch]);

    return (
        <BaseConfirmDialog
            size="small"
            dataQAId="ai-generation-reset-modal"
            buttons={[EButtonType.accept, EButtonType.cancel]}
            successButtonText="Сгенерировать"
            cancelButtonText="Не генерировать"
            renderContent={renderContent}
            renderHeader={renderHeader}
            onClose={handleClose}
            onSuccess={handleClick}
            isDarkTheme={true}
            className={VK_UI_DARK_THEME}
        />
    );
});
